import queryString from "query-string";

export type TSearchOptions = {
  page?: number;
  size?: number;
  sort?: string[];
};

export const DEFAULT_SEARCH_OPTIONS: TSearchOptions = {
  page: 0,
  size: 100,
};

export const createQS: <T extends TRequestParams>(data: T) => string = (data) => {
  if (!data) {
    return "";
  }

  const { sort, ...restData } = data;
  const baseQuery = queryString.stringify(restData);

  if (!sort || !Array.isArray(sort)) {
    return baseQuery;
  }

  const sortParams = sort.map((s) => `sort=${s}`).join("&");
  return baseQuery ? `${baseQuery}&${sortParams}` : sortParams;
};

export type TRequestParams = Record<string, TRequestValues>;

export type TRequestValues = TRequestValuePrimitive | TRequestValuePrimitive[];

export type TRequestValuePrimitive = string | number | undefined;
export type TResponseList<T> = {
  totalElements: number;
  content: Array<T>;
};
